import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/logo.png"
import logoDark from "../../assets/images/logo.png"

const Sidebar = props => {
  const [logoSize, setLogoSize] = useState(20)
  useEffect(() => {
    const body = document.body

    const updateLogoSize = () => {
      const isExist =
        body.classList.contains("vertical-collpsed")

      setLogoSize(isExist ? 20 : 60)
    }

    // Initial check
    updateLogoSize()

    // Observer for class changes
    const observer = new MutationObserver(() => {
      updateLogoSize()
    })

    observer.observe(body, {
      attributes: true,
      attributeFilter: ["class"], // watch only class changes
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="60" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="60" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="" height={logoSize} />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height={logoSize} />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
